import React from 'react'
import { useTheme } from '@/context/ThemeContext'
import type { ActionDecision } from '../types'

const OPTIONS: { value: ActionDecision; label: string }[] = [
  { value: 'auto', label: 'Auto' },
  { value: 'approval', label: 'Ask first' },
  { value: 'disabled', label: 'Off' },
]

type Props = {
  value: ActionDecision
  onChange: (value: ActionDecision) => void
  disabled?: boolean
}

const DecisionToggle: React.FC<Props> = ({ value, onChange, disabled }) => {
  const { currentTheme: t } = useTheme()

  return (
    <div
      className="inline-flex items-center gap-1 rounded-lg p-1 shrink-0"
      style={{ backgroundColor: t.sectionBackground, border: `1px solid ${t.border}` }}
    >
      {OPTIONS.map((opt) => {
        const isActive = value === opt.value
        return (
          <button
            key={opt.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange(opt.value)}
            className="h-7 px-2.5 rounded-md text-[11.5px] font-medium transition-colors whitespace-nowrap disabled:cursor-not-allowed disabled:opacity-60"
            style={{
              backgroundColor: isActive ? (opt.value === 'disabled' ? t.errorBackground : t.accent) : 'transparent',
              color: isActive ? (opt.value === 'disabled' ? t.errorText : t.buttonText) : t.secondrytext,
            }}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}

export default React.memo(DecisionToggle)
